import { render, staticRenderFns } from "./Transferencia-fondos.vue?vue&type=template&id=72cc143a&scoped=true"
import script from "./Transferencia-fondos.vue?vue&type=script&lang=js"
export * from "./Transferencia-fondos.vue?vue&type=script&lang=js"
import style0 from "./Transferencia-fondos.vue?vue&type=style&index=0&id=72cc143a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cc143a",
  null
  
)

export default component.exports